var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-devoluciones"},[_c('p',{staticClass:"text-footer-devoluciones"},[_vm._v(" ¿Necesitas ayuda? Comunícate con nuestra línea de atención "),_c('a',{attrs:{"href":"tel:573232747474"}},[_vm._v("323 274 7474")])])])
}]

export { render, staticRenderFns }